<div class="account-admins-container">
  <div
    class="flexed flex-space-between"
    style="padding: 8px; margin-bottom: 8px"
  >
    <ion-searchbar
      mode="ios"
      placeholder="Search admins..."
      showCancelButton="never"
      class="rounded-search-bar"
      (ionInput)="handleSearch($event)"
    ></ion-searchbar>
    <div class="flexed-align-center">
      <ion-chip
        mode="ios"
        class="select-chip select-outline"
        [outline]="true"
        (click)="selectUser()"
      >
        <ion-label>
          {{ selectedUser?.title || "Add account admin" }}
          <ion-icon
            name="chevron-down-outline"
            class="icon-padded-left chevron-icon"
          ></ion-icon>
        </ion-label>
      </ion-chip>
      <ion-button
        class="btn-small"
        (click)="submit()"
        [disabled]="!isValidNewAdmin() || isSubmitting"
      >
        Add Admin
      </ion-button>
    </div>
  </div>

  <ion-card class="outline-card">
    <ngx-datatable
      class="material datatable-row-borders"
      [columnMode]="ColumnMode.force"
      [limit]="limit"
      [headerHeight]="44"
      [footerHeight]="50"
      [rowHeight]="50"
      [scrollbarH]="true"
      style="height: unset"
      paginated
      [dataSource]="accountAdminsDataSource"
      [loadingIndicator]="isLoading"
    >
      <ngx-datatable-column name="User" [minWidth]="200">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flexed-align-center">
            <app-avatar
              [size]="20"
              [style.height.px]="20"
              [style.width.px]="20"
              [name]="row.user?.name || row.user?.email"
              [image]="row.user?.photo"
            ></app-avatar>
            <div style="margin-left: 10px">
              <div>{{ row.user?.name || row.user?.email || "Unknown" }}</div>
              <div style="font-size: 12px; color: var(--ion-text-color)">
                {{ row.user?.email }}
              </div>
            </div>
          </div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        name=""
        [minWidth]="100"
        [maxWidth]="100"
        [sortable]="false"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <a
            (click)="removeAdmin(row.userId, row.user?.name)"
            *ngIf="canEditAdmins"
            style="color: var(--ion-color-danger)"
          >
            Remove
          </a>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </ion-card>
</div>
